module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/98.85bf753a.png";